import React from 'react'
import { Table } from 'antd'
import { NoData, TableContainer } from 'components'
import ProjectListColumns from 'views/UserManagement/Projects/components/ProjectListColumns'

function ProjectList({ data, loading }) {
	return (
		<TableContainer>
			{data && !loading && (
				<Table
					rowKey="id"
					pagination={{ hideOnSinglePage: true }}
					columns={ProjectListColumns()}
					dataSource={data}
					loading={loading}
					locale={{
						emptyText: <NoData />
					}}
				/>
			)}
		</TableContainer>
	)
}

export default ProjectList
